import { Box, Button, Card, CardHeader } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NotifyIcon, NotifyTypo } from 'web-components';
import { getPlcProtocolName } from 'attrs/plcConfigValues';
import withLoadingState from '../../../../helpers/withLoadingState';

const labelAmend = 'machines.detail';

interface AutomationSystemCardProps {
  setDisplayEditAutomationSystemModal: React.Dispatch<React.SetStateAction<boolean>>;
  automationSystem: {
    plc_type: string;
  };
}

const AutomationSystemCard = ({ setDisplayEditAutomationSystemModal, automationSystem }: AutomationSystemCardProps) => {
  const { t } = useTranslation();

  return (
    <Card sx={{ p: 4, my: 2 }}>
      <CardHeader
        sx={{ p: 0, alignItems: 'flex-start', mb: 0 }}
        action={
          <span>
            <Button
              variant="text"
              disabled={false}
              sx={{ p: 1.5, gap: 1, display: 'flex', height: '50px', width: '96px' }}
              onClick={() => setDisplayEditAutomationSystemModal(true)}
            >
              <NotifyIcon iconName="edit" fontSize="medium" />
              {t('machines.machine_details.edit')}
            </Button>
          </span>
        }
        title={
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ mt: '15px', fontSize: '16px' }}>{t(`${labelAmend}.automation_system.title`)}</Box>
          </Box>
        }
        titleTypographyProps={{
          fontWeight: '500',
          variant: 'body1'
        }}
      />
      <NotifyTypo.Subtitle1 fontWeight="400">{t(`${labelAmend}.automation_system.subtitle`)}</NotifyTypo.Subtitle1>
      <Box sx={{ my: '20px' }}>
        <NotifyTypo.Subtitle2 fontWeight="400">{t(`${labelAmend}.automation_system.model`)}</NotifyTypo.Subtitle2>
        <NotifyTypo.Body1 fontWeight="400">{getPlcProtocolName(automationSystem.plc_type, false)}</NotifyTypo.Body1>
      </Box>
    </Card>
  );
};

export default withLoadingState(AutomationSystemCard);
